import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, SubmenusState } from './submenus.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state.submenus);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelected = createSelector(getState, (state: SubmenusState) => state.selectedTag);
const getSelectedSearchSubmenu = createSelector(getState, (state: SubmenusState) => state.selectedSearchTag);

const getValidAll = createSelector(
  entitySelectors.selectAll,
  asyncActionStateSelectors.getHasError,
  asyncActionStateSelectors.getSuccess,
  (submenus, hasError, success) => (!hasError && success ? submenus : null)
);

const getIsEmpty = createSelector(entitySelectors.selectAll, (submenus) => RA.isNilOrEmpty(submenus));

export const SubmenusSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelected,
    getSelectedSearchSubmenu,
    getValidAll,
    getIsEmpty,
};
